import React, { useEffect, useState } from "react";
import { Button } from "antd";
import styled from "styled-components";
import attemptIcon from "../../../../../assets/images/Event-2025/attempt-coin.svg";
import plusIcon from "../../../../../assets/images/Event-2025/plus.svg";
import minusIcon from "../../../../../assets/images/Event-2025/minus.svg";
import placeBidIcon from "../../../../../assets/images/Event-2025/place-bid.png";
import "./index.scss";
import { MISSION_CARD_TYPE as TYPE } from "../../../../../helper/const";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { curStateAccount } from "../../../../../Redux/selector";

export default function CardChange({
  type = TYPE.change,
  bid,
  setBid,
  handleChangeBid,
}) {
  const { t } = useTranslation();
  const selectorAccount = useSelector(curStateAccount);
  const [bidTotal, setBidTotal] = useState(0);
  const [isCheckContent, setIsCheckContent] = useState(false);

  useEffect(() => {
    if (selectorAccount.remainTurn) {
      const bidTotal = selectorAccount.remainTurn?.reduce((acc, pack) => {
        return acc + pack?.turn;
      }, 0);
      setBidTotal(bidTotal);
    }
  }, [selectorAccount.remainTurn]);
  const handleAddBid = () => {
    if (+bid === +bidTotal) {
      return setIsCheckContent(true);
    }
    setBid(bid + 1);
  };

  const handleMinusBid = () => {
    if (bid > 1) {
      setBid(bid - 1);
      setIsCheckContent(false);
    }
  };
  return (
    <CardContainer
      isEarnAll={type === TYPE.earnChangeAll}
      className="mission-card container-mission-card"
    >
      <CardTitle>
        <div className="card-title-wrapper">
          <img src={placeBidIcon} alt="mission card icon" />
          <div className="card-title-inner-wrapper">
            <span className="card-title">
              {t("event_thingyan.home_page.1_bid_1_coin")}
            </span>
            <Prize>
              <img
                src={attemptIcon}
                alt="attempt icon"
                width={30}
                height={30}
              />
              <span className="prize-text">
                {`+1 ${t("event_thingyan.home_page.coins").replace(
                  "coins",
                  "coin"
                )}`}
              </span>
            </Prize>
          </div>
        </div>
      </CardTitle>
      <div className="change-bid-action-wrapper">
        <div className="change-bid-action-inner-wrapper">
          <Button
            icon={<img src={minusIcon} alt="minus icon" />}
            className="change-bid-action-btn"
            onClick={handleMinusBid}
          />
          <span className="bid-number">{bid}</span>
          <Button
            icon={<img src={plusIcon} alt="plus icon" />}
            className="change-bid-action-btn"
            onClick={handleAddBid}
          />
        </div>

        <ChangeButton
          type="primary"
          onClick={handleChangeBid}
          className="card-button scale-hover-item__btn"
        >
          {bid === 1
            ? t("event_thingyan.home_page.change_bids")
                .replace("_X_", bid)
                .replace("Turns", "Turn")
            : t("event_thingyan.home_page.change_bids").replace("_X_", bid)}
        </ChangeButton>
      </div>
      {isCheckContent ? (
        <div className="content-error-bid">
          ဝမ်းနည်းပါတယ်။ Coins တွေ လဲလှယ်ဖို့ ကစားခွင့် မလုံလောက်ပါ။
        </div>
      ) : null}
    </CardContainer>
  );
}

const CardContainer = styled.div`
  background-color: ${(props) => (props.isEarnAll ? "" : "white")};
  border-radius: ${(props) => (props.isEarnAll ? "0" : "20px")};
  padding: ${(props) => (props.isEarnAll ? "0" : "13px")};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  z-index: 9;

  .content-error-bid{
    font-size: 12px;
    line-height: 1;
    font-style: italic;
    color: red
  }

  .card-button {
    justify-content: center;
  }

  .card-more-container {
    padding: 20px;
    background-color: white;
    border-radius: 20px;
  }

  .earn-container {
    .card-title-inner-wrapper {
      .card-title {
        padding-bottom: 8px;
      }
    }
  }

  @media (max-width: 320px) {
    max-width: 100%;
    padding: 8px;
  }

  /* & + & {
    margin-top: 8px;

    @media (min-width: 425px) {
      margin-top: 12px;
    }
  } */
`;

const CardTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  .item-flex-center {
    display: flex;
    justify-content: flex-start;
    gap: 12px;
    width: 100%;
  }
  @media (max-width: 425px) {
    gap: 8px;
  }
`;

const ChangeButton = styled(Button)`
  background-color: var(--bg-orange);
  width: 100%;
  padding: 12px;
  min-height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;

  &:hover {
    background-color: var(--bg-orange) !important;
  }

  &:active {
    background-color: var(--bg-orange) !important;
  }
`;

const Prize = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .prize-text {
    color: var(--text-blue);
    font-weight: bold;
    font-size: 14px;

    &.text-gold {
      color: var(--text-orange);
    }
  }

  & > img {
    width: 32px;
    height: 32px;
  }

  @media (max-width: 475px) {
    gap: 4px;
    & > img {
      width: 24px;
      height: 24px;
    }
    .prize-text {
      font-size: 12px;
    }
  }

  @media (max-width: 375px) {
    .prize-text {
      font-size: 10px;
    }
  }
`;
